/* Wrap add to cart in the product page */
function wrapProductForm() {
  const inputElement = document.querySelector('.product-form__quantity');
  const formElement = document.querySelector('.product-form');

  if (inputElement && formElement) {
    if (!formElement.parentElement.classList.contains('add-to-cart-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'add-to-cart-wrapper';
      formElement.parentNode.insertBefore(wrapper, formElement);
      wrapper.appendChild(inputElement);
      wrapper.appendChild(formElement);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  wrapProductForm();
});

const modalOpeners = document.querySelectorAll('.quick-add__submit');
modalOpeners.forEach(modalOpener => {
  modalOpener.addEventListener('click', () => {
    setTimeout(wrapProductForm, 300);
  });
});

/* Fancybox init */
Fancybox.bind("[data-fancybox='gallery']", {});

/* Custom sorting */
// Global state holders for filters
const priceFilters = {
  desktop: { min: null, max: null },
  mobile: { min: null, max: null }
};

const metafieldFilters = {
  desktop: {},
  mobile: {}
};

// Initialize price slider with device identifier ('desktop' or 'mobile')
function initPriceSlider(id, device) {
  const priceSlider = document.getElementById(id);
  if (!priceSlider || priceSlider.noUiSlider) return;

  const maxValue = parseInt(priceSlider.dataset.max, 10) || 1000;

  const urlParams = new URLSearchParams(window.location.search);
  const minValue = parseInt(urlParams.get('filter.v.price.gte')) || 0;
  const maxSelected = parseInt(urlParams.get('filter.v.price.lte')) || maxValue;

  noUiSlider.create(priceSlider, {
    start: [minValue, maxSelected],
    connect: true,
    range: { min: 0, max: maxValue },
    step: 10,
    tooltips: [true, true],
    format: {
      to: value => Math.round(value),
      from: value => Number(value)
    }
  });

  priceSlider.noUiSlider.on('change', function (values) {
    // Save values for later apply, no reload here
    priceFilters[device] = { min: values[0], max: values[1] };
  });

  // Initialize current state to slider start values:
  priceFilters[device] = { min: minValue, max: maxSelected };
}

// Create simulated metafield slider for desktop or mobile
function createSimulatedMetafieldSlider(paramName, sliderId, containerSelector, mobile = false) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const checkboxes = container.querySelectorAll(`input[name="${paramName}"]`);
  if (!checkboxes.length) return;

  let checkboxWrapper;
  if (mobile) {
    checkboxWrapper = container.querySelector('.mobile-facets__list');
  } else {
    checkboxWrapper = container.querySelector('.facets__display-vertical');
  }
  if (!checkboxWrapper) return;
  checkboxWrapper.style.display = 'none';

  if (container.querySelector(`#${sliderId}`)) return;

  const sliderWrapper = document.createElement('div');
  sliderWrapper.style.margin = mobile ? '35px 40px 50px' : '35px 0 50px';
  sliderWrapper.innerHTML = `<div id="${sliderId}"></div>`;

  if (mobile) {
    const closeButton = container.querySelector('.mobile-facets__close-button');
    if (closeButton && closeButton.parentNode) {
      closeButton.parentNode.insertBefore(sliderWrapper, closeButton.nextSibling);
    } else {
      container.appendChild(sliderWrapper);
    }
  } else {
    checkboxWrapper.parentElement.appendChild(sliderWrapper);
  }

  const values = Array.from(checkboxes).map(cb => parseFloat(cb.value)).filter(v => !isNaN(v));
  const min = Math.min(...values);
  const max = Math.max(...values);

  const urlParams = new URLSearchParams(window.location.search);
  const gteParam = `${paramName}.gte`;
  const lteParam = `${paramName}.lte`;
  let gte = parseFloat(urlParams.get(gteParam));
  let lte = parseFloat(urlParams.get(lteParam));

  if (isNaN(gte) || isNaN(lte)) {
    const checkedValues = Array.from(checkboxes)
      .filter(cb => cb.checked)
      .map(cb => parseFloat(cb.value));
    if (checkedValues.length) {
      gte = Math.min(...checkedValues);
      lte = Math.max(...checkedValues);
    } else {
      gte = min;
      lte = max;
    }
  }

  const slider = sliderWrapper.querySelector(`#${sliderId}`);
  if (!slider || slider.noUiSlider) return;

  noUiSlider.create(slider, {
    start: [gte, lte],
    connect: true,
    range: { min, max },
    step: 1,
    tooltips: true,
    format: {
      to: value => Math.round(value),
      from: value => Number(value)
    }
  });

  slider.noUiSlider.on('change', function ([minVal, maxVal]) {
    checkboxes.forEach(cb => {
      const val = parseFloat(cb.value);
      cb.checked = val >= minVal && val <= maxVal;
    });

    // Save current checked state, no form submit here
    const device = mobile ? 'mobile' : 'desktop';
    metafieldFilters[device][paramName] = Array.from(checkboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);
  });

  // Save initial checked state on load
  const device = mobile ? 'mobile' : 'desktop';
  metafieldFilters[device][paramName] = Array.from(checkboxes)
    .filter(cb => cb.checked)
    .map(cb => cb.value);
}

// Initialize all sliders (price + metafield)
function initSliders() {
  // Price sliders
  initPriceSlider('price-slider-desktop', 'desktop');
  initPriceSlider('price-slider-mobile', 'mobile');

  // Metafield sliders: width_cm
  createSimulatedMetafieldSlider('filter.p.m.custom.width_cm', 'width-slider-desktop', '#Details-2-template--25044176732493__product-grid', false);
  createSimulatedMetafieldSlider('filter.p.m.custom.width_cm', 'width-slider-desktop', '#Details-2-template--25044177387853__main', false);
  createSimulatedMetafieldSlider('filter.p.m.custom.width_cm', 'width-slider-mobile', '#FacetMobile-2-template--25044176732493__product-grid', true);
  createSimulatedMetafieldSlider('filter.p.m.custom.width_cm', 'width-slider-mobile', '#FacetMobile-2-template--25044177387853__main', true);

  // Metafield sliders: ilgis_cm (depth)
  createSimulatedMetafieldSlider('filter.p.m.custom.ilgis_cm', 'depth-slider-desktop', '#Details-3-template--25044176732493__product-grid', false);
  createSimulatedMetafieldSlider('filter.p.m.custom.ilgis_cm', 'depth-slider-desktop', '#Details-3-template--25044177387853__main', false);
  createSimulatedMetafieldSlider('filter.p.m.custom.ilgis_cm', 'depth-slider-mobile', '#FacetMobile-3-template--25044176732493__product-grid', true);
  createSimulatedMetafieldSlider('filter.p.m.custom.ilgis_cm', 'depth-slider-mobile', '#FacetMobile-3-template--25044177387853__main', true);

  // Metafield sliders: aukstis_cm (height)
  createSimulatedMetafieldSlider('filter.p.m.custom.aukstis_cm', 'height-slider-desktop', '#Details-4-template--25044176732493__product-grid', false);
  createSimulatedMetafieldSlider('filter.p.m.custom.aukstis_cm', 'height-slider-desktop', '#Details-4-template--25044177387853__main', false);
  createSimulatedMetafieldSlider('filter.p.m.custom.aukstis_cm', 'height-slider-mobile', '#FacetMobile-4-template--25044176732493__product-grid', true);
  createSimulatedMetafieldSlider('filter.p.m.custom.aukstis_cm', 'height-slider-mobile', '#FacetMobile-4-template--25044177387853__main', true);
}

// Apply filters by collecting slider and checkbox states and updating URL
function applyFilters(device) {
  const params = new URLSearchParams(window.location.search);

  // Remove page parameter to reset pagination
  params.delete('page');

  // Price filters (Shopify supports gte/lte for price)
  if (priceFilters[device]) {
    params.set('filter.v.price.gte', priceFilters[device].min);
    params.set('filter.v.price.lte', priceFilters[device].max);
  }

  // Remove existing metafield filter params to avoid duplicates
  for (const key of Array.from(params.keys())) {
    if (key.startsWith('filter.p.m.custom.')) {
      params.delete(key);
    }
  }

  // Add selected metafield values (as separate param instances)
  const deviceMetafields = metafieldFilters[device] || {};
  for (const [paramName, values] of Object.entries(deviceMetafields)) {
    values.forEach(value => {
      params.append(paramName, value);
    });
  }

  const baseUrl = window.location.origin + window.location.pathname;
  window.location.href = baseUrl + '?' + params.toString();
}

// Add Filtruoti buttons dynamically if they don't exist yet
function addFilterButtons() {
  let desktopBtn = document.getElementById('apply-filters-desktop');
  let mobileBtn = document.getElementById('apply-filters-mobile');
  if(!desktopBtn) return;
  desktopBtn.addEventListener('click', () => applyFilters('desktop'));
  mobileBtn.addEventListener('click', () => applyFilters('mobile'));
}

// Initialization after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initSliders();
  addFilterButtons();

  // Observe filter container for AJAX updates to re-init sliders
  const observerTarget = document.querySelector('[data-filters]') || document.body;
  const observer = new MutationObserver(() => {
    initSliders();
  });
  observer.observe(observerTarget, { childList: true, subtree: true });
});

/* Collection read more */
(() => {
  function countWords(text) {
    const t = (text || '').trim()
    if (!t) return 0
    return t.split(/\s+/).length
  }

  function truncateElementToWords(el, limit) {
    if (!el || !limit || countWords(el.textContent) <= limit) return false

    const clone = el.cloneNode(true)
    let wordsLeft = limit
    let truncated = false

    function walk(node) {
      if (truncated) {
        node.remove()
        return
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.nodeValue.split(/(\s+)/)
        let used = 0
        let out = ''

        for (const part of parts) {
          if (!part.trim()) {
            out += part
            continue
          }
          if (used < wordsLeft) {
            out += part
            used++
          } else break
        }

        if (used < parts.filter(p => p.trim()).length) {
          node.nodeValue = out.replace(/\s+$/, '') + '…'
          wordsLeft = 0
          truncated = true
        } else {
          wordsLeft -= used
        }
        return
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(walk)
        if (!node.textContent.trim() && !node.children.length) node.remove()
      }
    }

    walk(clone)

    el.innerHTML = ''
    while (clone.firstChild) el.appendChild(clone.firstChild)
    return true
  }

  document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.js-readmore')
    if (!wrappers.length) return

    wrappers.forEach(wrapper => {
      if (!wrapper.dataset.limit) return

      const limit = parseInt(wrapper.dataset.limit, 10)
      if (!limit || limit < 1) return

      const content = wrapper.querySelector('.collection-long-description__content')
      const button = wrapper.querySelector('.collection-long-description__read-more')
      if (!content || !button) return

      const originalHTML = content.innerHTML
      if (!truncateElementToWords(content, limit)) return

      button.hidden = false
      button.addEventListener('click', () => {
        content.innerHTML = originalHTML
        button.remove()
      })
    })
  })
})()
/* Make homepage slideshow image clickable */
document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('slideshow-component .slideshow__slide');

  slides.forEach(function (slide) {
    slide.style.cursor = 'pointer';

    slide.addEventListener('click', function (event) {
      if (
        event.target.closest('a') ||
        event.target.closest('button') ||
        event.target.closest('.slider-button') ||
        event.target.closest('.slideshow__controls')
      ) {
        return;
      }

      window.location.href = '/collections/baldai-sandelyje';
    });
  });
});